import axioslib, { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthInterceptor } from "@/api/AuthInterceptor";
import VersionInterceptor from "@/api/VersionInterceptor";
import { IDiscountInfo, Logger, ResponseStatus } from "@iloq/shared";

export enum DiscountNotAvailableCause {
  REVIEW_DECLINED = "REVIEW_DECLINED",
  OPPORTUNITY_LOST = "OPPORTUNITY_LOST",
  LAST_ORDER_DATE_PASSED = "LAST_ORDER_DATE_PASSED",
  UNDER_REVIEW = "UNDER_REVIEW",
}

export interface DiscountNotAvailable {
  discountNotAvailableCause: DiscountNotAvailableCause;
}

export default class PartnerInfoApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  async fetchDiscountInfo(
    projectDiscountCode: string,
  ): Promise<IDiscountInfo | DiscountNotAvailable> {
    const options: AxiosRequestConfig = {
      method: "GET",
      url: `/api/v1/project/discounts/${projectDiscountCode}`,
    };

    try {
      const { data } = await this.axios(options);
      Logger.debug("ProjectApi.fetchDiscountInfo result:", data);
      return data;
    } catch (error) {
      const axiosError = error as AxiosError<{ discountNotAvailableCause?: string }>;
      if (
        axiosError.response?.status === ResponseStatus.notFound &&
        axiosError.response?.data.discountNotAvailableCause
      ) {
        if (axiosError.response.data.discountNotAvailableCause === "REVIEW_DECLINED") {
          return { discountNotAvailableCause: DiscountNotAvailableCause.REVIEW_DECLINED };
        }
        if (axiosError.response.data.discountNotAvailableCause === "OPPORTUNITY_LOST") {
          return { discountNotAvailableCause: DiscountNotAvailableCause.OPPORTUNITY_LOST };
        }
        if (axiosError.response.data.discountNotAvailableCause === "LAST_ORDER_DATE_PASSED") {
          return { discountNotAvailableCause: DiscountNotAvailableCause.LAST_ORDER_DATE_PASSED };
        }
        if (axiosError.response.data.discountNotAvailableCause === "UNDER_REVIEW") {
          return { discountNotAvailableCause: DiscountNotAvailableCause.UNDER_REVIEW };
        }
      }
      Logger.error("ProjectApi.fetchDiscountInfo failed:", error);
      throw error;
    }
  }
}
